import { render, staticRenderFns } from "./smsMessage.vue?vue&type=template&id=0e2719c0&lang=pug&"
import script from "./smsMessage.vue?vue&type=script&lang=ts&"
export * from "./smsMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports